export enum API_URL {
  PRICING_LEVEL_CREATE = "/pricing_level/create",
  PRICING_LEVEL_GET = "pricing_level/get",
  PRICING_LEVEL_LIST = "/pricing_level/list",
  PRICING_LEVEL_UPDATE = "/pricing_level/update",
}
